import request from '@/utils/request'

export function vedioPlayer(vid, courseId) {
    return request({
        url: 'api/aliyun/GetVideoPlayAuth',
        method: 'get',
        params: {
            vid: vid,
            courseId: courseId
        }

    })
}

export function createUrl(url) {
    return request({
        url: 'api/aliyun/initVodClient',
        method: 'get',
        params: {
            title: url
        }

    })
}

export function playAuth(id) {
    return request({
        url: 'api/aliyun/GetVideoPlayAuth',
        method: 'get',
        params: {
            courseId: id,
        }
    })
}

//用户看课记录日志
export function courseStudy(data){
    return request({
        url:'api/loginLog/course/course/study',
        method:'post',
        data
    })
}

export function institutionStudy(data){
    return request({
        url:'api/loginLog/institutionCourse/institutionCourse/study',
        method:'post',
        data
    })
}
